import * as React from 'react';
import {
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useQueryOptionsFromSearchParams,
} from 'gossamer-front-end';
import { Event } from 'cb-model';
import { getFilter, QueryOptions } from 'gossamer-unified';
import { useInstitutionFilter } from '../institution/useInstitutionFilter';

export const OnDemandEventSearch = (): React.JSX.Element => {
  const initialQueryOptions = useInstitutionFilter({
    where: {
      and: [
        getFilter('institution_id', 'eq', '', 'hidden'),
        getFilter('title', 'sw', ''),
        getFilter('type', 'eq', 'on-demand', 'hidden'),
        getFilter('visibility_limit', 'ne', 'cancelled', 'hidden'),
      ],
    },
    order: [['title', 'ASC']],
  } as QueryOptions);
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(Event, initialQueryOptions);
  const gCacheQueryItem = useCacheQuery(Event, queryOptions);
  return (
    <Section>
      <PaginatorAndListSettings
        entity={Event}
        gCacheQuery={gCacheQueryItem}
        queryOptions={queryOptions}
        render={Search}
        setQueryOptions={setQueryOptions}
      />
    </Section>
  );
};
